import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import classNames from 'classnames'

import { TeamPageQuery } from '../../types/graphql'

import { Layout } from '../../components/Layout'
import { SEO } from '../../components/SEO'
import { SocialLinks } from '../../components/SocialLinks'

import * as classes from './team.module.scss'

const TeamPage = () => {
  const { allStrapiPeople } = useStaticQuery<TeamPageQuery>(graphql`
    query TeamPage {
      allStrapiPeople(sort: { order: ASC, fields: order }) {
        nodes {
          id
          name
          role
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO title='Team' />
      <div className={classNames(['container', classes.team])}>
        <SocialLinks />
        <div className={classes.members}>
          {allStrapiPeople.nodes!.map((node) => (
            <div className={classes.member} key={node.id}>
              <h4>{node.name}</h4>
              <h5>{node.role}</h5>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default TeamPage
